// Redux
import { createListenerMiddleware, isAnyOf } from '@reduxjs/toolkit';
import { addToast } from '../../slices/toastSlice';

// APIs
import { contentApi } from '../../api/contentApi';
import { contentContextApi } from '../../api/contentContextApi';
import { flowApi } from '../../api/flowApi';
import { mediaApi } from '../../api/mediaApi';
import { userApi } from '../../api/UserListApi';
import { notificationConfigurationsApi } from '../../api/notificationConfigurationApi';
import { versionManagmentApi } from '../../api/versionManagment';
import { broadcastApi } from '../../api/broadcastApi';
import { sessionsApi } from '../../api/sessionsApi';
import { questionnaireApi } from '../../api/questionnaireApi';

// Helpers
import { getEntityName } from './helpers/getEntityName';
import { getActionType } from './helpers/getActionType';
import { isMutationName } from './helpers/isMutationName';

// i18n
import i18next from 'i18next';

const listenerMiddleware = createListenerMiddleware();

const apis = [
  contentApi,
  contentContextApi,
  flowApi,
  mediaApi,
  userApi,
  notificationConfigurationsApi,
  versionManagmentApi,
  broadcastApi,
  sessionsApi,
  questionnaireApi,
];

const fulfilledActions = apis.flatMap((api) =>
  Object.entries(api.endpoints)
    .filter(([name]) => isMutationName(name))
    .map(([, endpoint]) => endpoint.matchFulfilled)
);

const rejectedActions = apis.flatMap((api) =>
  Object.entries(api.endpoints)
    .filter(([name]) => isMutationName(name))
    .map(([, endpoint]) => endpoint.matchRejected)
);

listenerMiddleware.startListening({
  predicate: isAnyOf(...fulfilledActions),
  effect: async (action, { dispatch }) => {
    const endpointName = (action.meta as any).arg?.endpointName ?? '';
    const entity = getEntityName(endpointName);
    const verb = getActionType(endpointName);

    const message = i18next.t(`toast.success.${verb}`, { entity });
    dispatch(addToast({ message, type: 'success' }));
  },
});

listenerMiddleware.startListening({
  predicate: isAnyOf(...rejectedActions),
  effect: async (action, { dispatch }) => {
    const endpointName = (action.meta as any).arg?.endpointName ?? '';
    const entity = getEntityName(endpointName);
    const verb = getActionType(endpointName);

    const message = i18next.t(`toast.error.${verb}`, { entity });
    dispatch(addToast({ message, type: 'error' }));
  },
});

export default listenerMiddleware.middleware;
